import React from 'react';

const Windowed = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			data-name="Group 2926"
			viewBox="0 0 18.1 18.1"
			className={className}
		>
			<path
				fill="#209022"
				d="M6.798 2.252h9.05V11.3h-9.05ZM4.525 13.575H18.1V0H4.525Z"
				data-name="Path 1349"
			/>
			<path
				fill="#209022"
				d="M0 4.525V18.1h13.575v-2.253H2.252V4.525Z"
				data-name="Path 1350"
			/>
		</svg>
	);
};

export default Windowed;
